var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.941,
    height: 45.057,
    viewBox: "0 0 43.941 45.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10635",
    "data-name": "Group 10635",
    transform: "translate(-436 -791.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10585",
    "data-name": "Group 10585",
    transform: "translate(414 784.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15845",
    "data-name": "Path 15845",
    d: "M22,13V47.551a3,3,0,0,0,.122.893,2.526,2.526,0,0,0,2.319,1.987H63.5A2.555,2.555,0,0,0,65.855,48.3a2.972,2.972,0,0,0,.085-.749V13Z",
    transform: "translate(0 1.626)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15847",
    "data-name": "Path 15847",
    d: "M61.795,9.542v5.084H44V7H59.253A2.55,2.55,0,0,1,61.795,9.542Z",
    transform: "translate(4.145)",
    fill: "#acd4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15851",
    "data-name": "Path 15851",
    d: "M58.312,7v7.626H22V9.542A2.55,2.55,0,0,1,24.542,7Z",
    transform: "translate(0)",
    fill: "#acd4f8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15852",
    "data-name": "Path 15852",
    d: "M46.168,14.626v7.626l-5.084-5.084L36,22.253V8.945H46.168Z",
    transform: "translate(417 790.257)",
    fill: "#4c36e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.5f35cf03f5446ef56ec2944adb115dae.svg";
export { ForwardRef as ReactComponent };